export default "__VITE_ASSET__DW6e6$mN__"